<template src="./printqrcode.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import QrCode from "@/pages/assets/qrcode/qrcode.vue";

  export default {
    components: { QrCode },
    data() {
      return {
        ShowLoader: false,
        AssetId: 0,
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicles Check View";
      this.AssetId = this.$route.params.Id;
    },
    methods: {
      PrintReport() {
        window.print();
      },
    },
  };
</script>
<style scoped>
  @media print {
    .print_btn {
      display: none;
    }
  }
</style>
